import { render, staticRenderFns } from "./Diplomacy.vue?vue&type=template&id=320a5712&scoped=true&"
import script from "./Diplomacy.vue?vue&type=script&lang=js&"
export * from "./Diplomacy.vue?vue&type=script&lang=js&"
import style0 from "./Diplomacy.vue?vue&type=style&index=0&id=320a5712&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a5712",
  null
  
)

export default component.exports